export default function Contact() {
  return (
    <footer className="bg-gradient-to-br from-emerald-900 via-teal-900 to-slate-900 text-white">
      {/* Main Contact Section */}
      <div className="max-w-7xl mx-auto px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center gap-3 mb-6">
              <img 
                src="https://public.readdy.ai/ai/img_res/a55b9b6d-60e9-42a4-a9a6-ec09dd1730d6.png" 
                alt="BOHOR DOO UZICE Logo" 
                className="h-12 w-12 object-contain"
              />
              <h3 className="text-xl font-bold text-gray-100">BOHOR DOO UZICE</h3>
            </div>
            <p className="text-sm text-gray-300 leading-relaxed">
              A team of experts developing modern applications for the iOS platform, enhancing user experience and mobile device security.
            </p>
          </div>

          {/* Contact Information */}
          <div className="space-y-4">
            <h4 className="text-xs uppercase tracking-widest text-gray-400 mb-6">GET IN TOUCH</h4>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <i className="ri-mail-line text-xl text-teal-400 mt-1"></i>
                <div>
                  <p className="text-sm text-gray-400 mb-1">Email</p>
                  <a href="mailto:help@bohordoouzice.com" className="text-base text-white hover:text-teal-400 transition-colors">
                    help@bohordoouzice.com
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-phone-line text-xl text-teal-400 mt-1"></i>
                <div>
                  <p className="text-sm text-gray-400 mb-1">Number</p>
                  <a href="tel:+12186337763" className="text-base text-white hover:text-teal-400 transition-colors">
                    +1 2186337763
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Location */}
          <div className="space-y-4">
            <h4 className="text-xs uppercase tracking-widest text-gray-400 mb-6">LOCATION</h4>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <i className="ri-map-pin-line text-xl text-teal-400 mt-1"></i>
                <div>
                  <p className="text-sm text-gray-400 mb-1">Address</p>
                  <p className="text-base text-white">DIMITRIJA TUCOVICA 151</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-building-line text-xl text-teal-400 mt-1"></i>
                <div>
                  <p className="text-sm text-gray-400 mb-1">City</p>
                  <p className="text-base text-white">Uzice, 500926</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-global-line text-xl text-teal-400 mt-1"></i>
                <div>
                  <p className="text-sm text-gray-400 mb-1">Country</p>
                  <p className="text-base text-white">Serbia</p>
                </div>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-xs uppercase tracking-widest text-gray-400 mb-6">QUICK LINKS</h4>
            <ul className="space-y-3">
              {['Home', 'About', 'Products', 'Features'].map((item) => (
                <li key={item}>
                  <button
                    onClick={() => {
                      const element = document.getElementById(item.toLowerCase());
                      if (element) {
                        element.scrollIntoView({ behavior: 'smooth' });
                      }
                    }}
                    className="text-base text-white hover:text-teal-400 transition-colors cursor-pointer"
                  >
                    {item}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Large Typography Section */}
      <div className="relative overflow-hidden py-20 px-8">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-[180px] font-bold text-gray-100/10 leading-none tracking-tight select-none">
            BOHOR
          </h2>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400">
              © 2024 BOHOR DOO UZICE. All rights reserved.
            </p>
            <p className="text-sm text-gray-400">
              Developing excellence in iOS applications
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}